<script setup>
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
import NetworkList from "./NetworkList.vue";
defineEmits(["closeNetworkFooter"]);
</script>

<template>
    <div id="network-footer">
        <IconClose class="size-4" @click="$emit('closeNetworkFooter')" />
        <NetworkList :country :language />
    </div>
</template>

<style scoped>
#network-footer {
  @apply w-full bg-white border-t-[1px];
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.1);
}
#network-footer svg {
  @apply h-4 w-4 cursor-pointer text-zinc-600 hover:text-black absolute top-4 right-4;
}
</style>
